import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { IndexType } from "./IndexType";

import { BaseTableDefinitionFactory } from "./BaseTableDefinitionFactory";
import { COLUMN_SELECTION } from "./TableDefinitionFactory.constants";
import { ProfileSettingKeys } from "./core/ProfileSettingKeys";
import { TableDefinition, BfxColDef } from "./TableDefinition";
import { ColumnFilterType } from "./ColumnFilterType";
import { CurrencyPairCalendarLookupService } from "../lookup/model/impl/CurrencyPairCalendarLookupService";

import { BlotterType, AssetClass } from "shared/cubiq-model-multi-asset";

// real service imports

import { CcyLookupService } from "../lookup/model/impl/CcyLookupService";
import { CcyPairLookupService } from "../lookup/model/impl/CcyPairLookupService";
import { ClientLookupService } from "../lookup/model/impl/ClientLookupService";

import { SystemConfigPromiseService } from "shared/auth-services";
import { ProfilePromiseActionService } from "../profile/impl/ProfilePromiseActionService";

import { SysFeatures } from "../model/core/SysFeatures";

import { Injectable } from "@angular/core";
import {
  COLUMN_ORDER_TYPE,
  COLUMN_INSTRUMENT,
  COLUMN_ORDER_PRODUCT,
  COLUMN_VALUE_DATE,
  COLUMN_CLIENT_CODE,
  COLUMN_DEALT_DIR,
  RENDERER_ORDER_TYPE_FUNC,
} from "./OrdersTableDefinitionFactory.constants";
import {
  COLUMN_INTER_INSTRUMENT,
  COLUMN_INTER_ORDER_PRODUCT,
} from "./InterventionTableDefinitionFactory.constants";
import { TranslateService } from "@ngx-translate/core";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { DETAIL_FILL_TABLE_DEFINITION_VER } from "./TableDefinitionFactory.constants";
import { DealtPricingService } from "../lookup/pricing/impl/DealtPricingService";
import { COLUMN_TRADE_INSTRUMENT } from "./TradeTableDefinitionFactory.constants";
import { OrderDataLookupService } from "../lookup/model/impl/OrderDataLookupService";
import { OrderTypeHelper } from "./orders/OrderTypeHelper";
import { AlgoStrategyLookupService } from "../lookup/model/impl/AlgoStrategyLookupService";
import { ValueDateHelper } from "./orders/ValueDateHelper";
import { ValueFormatterParams } from "ag-grid-community";
import { IsColumnFuncParams } from "ag-grid-community/dist/lib/entities/colDef";
import { BfxSysConfigUtilService } from "shared/auth-services";
import { BfxConfigService } from "shared/auth-services/system-config/bfx-config.service";
import { BfxConfigIDRefHelper } from "../../helper-services/bfx-config-id-ref-helper";

export const CLASS_EDITABLE: string = "editable";

@Injectable()
export class DetailFillTableDefinitionFactory extends BaseTableDefinitionFactory {
  protected defaultSortModel: any = [{ colId: "creationDate", sort: "desc" }];
  private myPrivateCommentsEnabled: boolean;
  private myVehiclCcyEnabled: boolean;
  private fwdColsEnabled: boolean = false;
  private myOrderTypeHelper: OrderTypeHelper;
  public myValueDateHelper: ValueDateHelper;
  protected myPartFillDisabledTypeText: string = "";

  private enabledOBO: boolean = false;

  constructor(
    profileService: ProfilePromiseActionService,
    // It is not possible to inject against an interface
    private _ccyLookupService: CcyLookupService,
    private _ccyPairLookupService: CcyPairLookupService,
    private _orderDataLookupService: OrderDataLookupService,
    private _clientLookup: ClientLookupService,
    private _sysConfigService: SystemConfigPromiseService,
    private translateService: TranslateService,
    protected currencyPairCalendarLookupService: CurrencyPairCalendarLookupService,
    dealtPricingService: DealtPricingService,
    private algoStrategyLookupService: AlgoStrategyLookupService,
    // FIXME Angular 13
    // private goldenLayoutService: GoldenLayoutService,
    private sysConfigUtil: BfxSysConfigUtilService,
    private configService: BfxConfigService,
  ) {
    super(profileService);
    this.myOrderTypeHelper = new OrderTypeHelper(
      this.myPartFillDisabledTypeText,
      this.algoStrategyLookupService,
      this.sysConfigUtil,
    );
    this.myValueDateHelper = new ValueDateHelper(currencyPairCalendarLookupService);

    configService.getUIConfig().then((config) => {
      this.enabledOBO = config && config.general ? config.general.oboEnabled : false;
    });
  }

  protected getTableProfileConfig(): Promise<any> {
    return new Promise<any>((res) => {
      res(null);
    });
  }

  protected handleTableProfileConfig(values: Array<any>): void {
    let config = values[0];

    if (config != null && this.getVersionIdentifier() == config.version) {
      this.determineDefaultConfig(values[0]);
    }
  }
  private fwdIsEditable(params: IsColumnFuncParams): boolean {
    // to align with inverse of:
    // MarketPtsSpinner.isCancelBeforeStart()
    // ClientPtsSpinner.isCanncelBeforeStart()
    // MarketAllInSpinner.isCancelBeforeStart()
    // ClientAllInSpinner.isCanncelBeforeStart()

    let isFwd =
      params != null &&
      params.node != null &&
      params.node.data != null &&
      (params.node.data.product === CubiqTS.Product.FWD ||
        params.node.data.product === CubiqTS.Product.NDF);

    return isFwd;
  }

  public createDef(): TableDefinition {
    super.createDef();

    let td = new TableDefinition(
      "key",
      "as_sort_id",
      // new RowDefinition([new DetailFillRowAdapter()])
    );

    // requestSubmissionTime's column
    td.setDefaultSort(1, "desc");

    let selectionColumn: BfxColDef = { suppressMenu: true };

    selectionColumn.field = COLUMN_SELECTION;
    selectionColumn.pinned = "left";
    selectionColumn.lockPosition = true;
    selectionColumn.checkboxSelection = true;
    selectionColumn.headerName = "(0)";
    selectionColumn.headerCheckboxSelection = true;
    selectionColumn.headerCheckboxSelectionFilteredOnly = true;
    selectionColumn.suppressSorting = true;
    selectionColumn.suppressMovable = true;
    selectionColumn.suppressResize = false;
    selectionColumn.suppressMenu = true;
    selectionColumn.columnFilterType = ColumnFilterType.NONE;
    selectionColumn.width = 60;
    selectionColumn.minWidth = 60;
    selectionColumn.position = this.position.next();
    selectionColumn.omitFromPicker = true;
    selectionColumn.disableInPicker = true;
    selectionColumn.indexType = IndexType.None;

    let defaultSelColStyle = ["status-icon-cell"];
    // enforced width on fixed column
    selectionColumn.cellClass = function (params) {
      let order: any = params.data;
      let styles = [...defaultSelColStyle];
      if (order.gammaTop) {
        styles.push("df.gamma.top");
      } else if (order.gammaBottom) {
        styles.push("df.gamma.bottom");
      } else if (order.gammaRung) {
        styles.push("df.gamma.rung");
      }
      return styles;
    }.bind(this);

    selectionColumn.valueGetter = function (params) {
      let ret = '<i class="icon icon-spacer"';
      let order: any = params.data;
      if (order.gammaTop) {
        ret = '<i class="icon boxicon-df-gamma-top"></i>';
      } else if (order.gammaBottom) {
        ret = '<i class="icon boxicon-df-gamma-bottom"></i>';
      } else if (order.gammaRung) {
        ret = '<i class="icon boxicon-df-gamma-rung"></i>';
      }

      return ret;
    }.bind(this);

    selectionColumn.cellRenderer = function (params) {
      let renderer: string = params.value != null ? params.value : "";
      return renderer;
    };

    td.addColumn(selectionColumn);

    // Client Name
    // client name
    let clNm: BfxColDef = { suppressMenu: true };
    clNm.headerName = "Client Name";
    clNm.field = "clientName";
    clNm.indexType = IndexType.String;
    clNm.minWidth = this.oneWs;
    clNm.width = this.tenWs;
    clNm.columnFilterType = ColumnFilterType.CLIENT;
    if (!this.restoreFromConfig(clNm)) {
      clNm.position = this.position.next();
    }
    td.addColumn(clNm);

    // client id
    let clientId: BfxColDef = { suppressMenu: true };
    clientId.headerName = "Client ID";
    clientId.field = COLUMN_CLIENT_CODE;
    clientId.indexType = IndexType.String;
    clientId.minWidth = this.oneWs;
    clientId.width = this.tenWs;
    clientId.columnFilterType = ColumnFilterType.CLIENTID;
    if (!this.restoreFromConfig(clientId)) {
      clientId.hide = true;
      clientId.position = this.position.next();
    }
    td.addColumn(clientId);

    // dealt pair
    let instrumentCol: BfxColDef = { suppressMenu: true };
    instrumentCol.headerName = "Instrument";
    instrumentCol.field = COLUMN_INSTRUMENT;
    instrumentCol.indexType = IndexType.String;
    instrumentCol.alias = [COLUMN_TRADE_INSTRUMENT, COLUMN_INTER_INSTRUMENT];
    instrumentCol.minWidth = this.threeWs;
    instrumentCol.width = this.sixWs;
    instrumentCol.hide = false;
    instrumentCol.columnFilterType = ColumnFilterType.CURRENCY_PAIR;
    instrumentCol.omitFromPicker = false;
    instrumentCol.columnFilterType = ColumnFilterType.CURRENCY_PAIR;

    if (!this.restoreFromConfig(instrumentCol)) {
      instrumentCol.position = this.position.next();
    }

    td.addColumn(instrumentCol);

    // dealt direction
    let intentCol: BfxColDef = { suppressMenu: true };

    intentCol.headerName = "Dir";
    intentCol.field = COLUMN_DEALT_DIR;
    intentCol.indexType = IndexType.String;
    intentCol.minWidth = this.threeWs;
    intentCol.width = this.threeWs;
    intentCol.cellRenderer = "intentRenderer";
    intentCol.cellClass = ["blotter_center_align_col intent_col"];
    intentCol.columnFilterType = ColumnFilterType.NONE;
    intentCol.columnFilterData = CubiqTS.OrderIntent;
    intentCol.valueGetter = function (params) {
      if (CubiqTS.RequestOrderType.CALL === params.data.requestedOrderType) {
        return "CALL";
      }

      switch (params.data.clientIntent) {
        case CubiqTS.OrderIntent.BUY:
          return "Buy";
        case CubiqTS.OrderIntent.SELL:
          return "Sell";
      }

      return "";
    };
    if (!this.restoreFromConfig(intentCol)) {
      intentCol.position = this.position.next();
    }
    td.addColumn(intentCol);
    // Dealt Amount = Fill Amount
    let remainingAmtColumn: BfxColDef = { suppressMenu: true };

    remainingAmtColumn.field = "remainingAmount";
    remainingAmtColumn.headerName = "Remaining Amt";
    remainingAmtColumn.minWidth = this.nineWs;
    remainingAmtColumn.width = this.elevenWs;
    remainingAmtColumn.disableInPicker = true;
    remainingAmtColumn.valueFormatter = this.formatRemainingAmt.bind(this);
    if (!this.restoreFromConfig(remainingAmtColumn)) {
      remainingAmtColumn.position = this.position.next();
    }
    remainingAmtColumn.cellClass = "blotter_amt_align";
    td.addColumn(remainingAmtColumn);

    // Dealt Amount = Fill Amount
    const executionAmtCd: BfxColDef = { suppressMenu: true };

    executionAmtCd.headerName = "Fill Amt";
    executionAmtCd.field = "fillAmount";
    executionAmtCd.indexType = IndexType.NaturalString;
    executionAmtCd.minWidth = this.nineWs;
    executionAmtCd.width = this.eightWs;
    executionAmtCd.isPriority = true;
    executionAmtCd.editable = true;

    executionAmtCd.cellClass = function (params) {
      let order: any = params.data;
      if (
        !order.partFillEnabled &&
        (order.orderType == CubiqTS.OrderType.LIMIT_TP ||
          order.orderType == CubiqTS.OrderType.MARKET ||
          order.orderType == CubiqTS.OrderType.MARKET_FOK ||
          order.orderType == CubiqTS.OrderType.MARKET_IOC)
      ) {
        return "blotter_amt_align";
      } else {
        return "blotter_priority_col blotter_amt_align";
      }
    }.bind(this);

    executionAmtCd.columnFilterType = ColumnFilterType.NUMBER;
    executionAmtCd.columnFilterData = null;
    executionAmtCd.disableInPicker = true;
    executionAmtCd.cellEditor = "fillAmtSpinner";
    executionAmtCd.editable = function (params) {
      // DfAmountSpinner.isCancelBeforeStart()
      // ignore row selection here.

      let partFillEnabled =
        params != null &&
        params.node != null &&
        params.node.data != null &&
        params.node.data.partFillEnabled;

      return partFillEnabled;
    }.bind(this);
    executionAmtCd.valueGetter = function (params) {
      let order: any = params.data;
      return order.fillAmount;
    };
    executionAmtCd.valueFormatter = function (params) {
      let order: any = params.data;
      let precisionLimit: number = 2;
      if (order.dealtCcy && order.dealtCcy.length === 3) {
        let ccy: CubiqTS.CurrencyImpl = this._ccyLookupService.getItem(order.dealtCcy);
        if (ccy != null) {
          precisionLimit = ccy.minorUnitsQty.toNumber();
        }
      }
      return this.formatAmts(params, precisionLimit);
    }.bind(this);
    if (!this.restoreFromConfig(executionAmtCd)) {
      executionAmtCd.position = this.position.next();
    }
    td.addColumn(executionAmtCd);

    // market spot
    let marketSpotColumn: BfxColDef = { suppressMenu: true };
    marketSpotColumn.field = "spotMarketRate";
    marketSpotColumn.headerName = "Market Spot";
    marketSpotColumn.indexType = IndexType.NaturalString;
    marketSpotColumn.valueFormatter = this.formatRate.bind(this);
    marketSpotColumn.minWidth = this.nineWs;
    marketSpotColumn.width = this.nineWs;
    marketSpotColumn.disableInPicker = true;
    marketSpotColumn.editable = (params: IsColumnFuncParams) => {
      return true;
    };
    marketSpotColumn.cellEditor = "marketSptSpinner";
    marketSpotColumn.cellClass = "blotter_priority_col blotter_amt_align";
    marketSpotColumn.valueGetter = (params) => {
      return params.data.spotMarketRate;
    };
    if (!this.restoreFromConfig(marketSpotColumn)) {
      marketSpotColumn.hide = false;
      marketSpotColumn.position = this.position.next();
    }
    td.addColumn(marketSpotColumn);

    // market forward points
    let marketForwardPointsColumn: BfxColDef = { suppressMenu: true };

    marketForwardPointsColumn.headerName = "Market Pts";
    marketForwardPointsColumn.field = "forwardMarketPoints";
    marketForwardPointsColumn.minWidth = this.nineWs;
    marketForwardPointsColumn.indexType = IndexType.NaturalString;
    marketForwardPointsColumn.width = this.nineWs;
    marketForwardPointsColumn.disableInPicker = true;
    marketForwardPointsColumn.editable = this.fwdIsEditable.bind(this);
    marketForwardPointsColumn.cellEditor = "marketPtsSpinner";
    marketForwardPointsColumn.cellClass = "blotter_priority_col blotter_amt_align fwdEdit";
    marketForwardPointsColumn.valueFormatter = this.formatPoints.bind(this);
    marketForwardPointsColumn.valueGetter = (params) => {
      let order: CubiqTS.OrderDataImpl = params.data;
      return order.product === CubiqTS.Product.SPT ? null : params.data.forwardMarketPoints;
    };
    if (!this.restoreFromConfig(marketForwardPointsColumn)) {
      marketForwardPointsColumn.hide = !this.fwdColsEnabled;
      marketForwardPointsColumn.position = this.position.next();
    }
    td.addColumn(marketForwardPointsColumn);

    // market all-in rate
    let marketForwardRateColumn: BfxColDef = { suppressMenu: true };
    marketForwardRateColumn.headerName = "Market All-In";
    marketForwardRateColumn.field = "forwardMarketRate";
    marketForwardRateColumn.minWidth = this.nineWs;
    marketForwardRateColumn.width = this.nineWs;
    marketForwardRateColumn.disableInPicker = true;
    marketForwardRateColumn.editable = this.fwdIsEditable.bind(this);
    marketForwardRateColumn.cellEditor = "marketAllInSpinner";
    marketForwardRateColumn.cellClass = "blotter_priority_col blotter_amt_align fwdEdit";
    marketForwardRateColumn.valueGetter = (params) => {
      let order: CubiqTS.OrderDataImpl = params.data;
      return order.product === CubiqTS.Product.SPT ? null : params.data.forwardMarketRate;
    };
    marketForwardRateColumn.valueFormatter = this.formatRate.bind(this);
    if (!this.restoreFromConfig(marketForwardRateColumn)) {
      marketForwardRateColumn.hide = !this.fwdColsEnabled;
      marketForwardRateColumn.position = this.position.next();
    }
    td.addColumn(marketForwardRateColumn);

    // client spot
    let clientSpotColumn: BfxColDef = { suppressMenu: true };
    clientSpotColumn.field = "clientSpot";
    clientSpotColumn.headerName = "Client Spot";
    clientSpotColumn.valueFormatter = this.formatRate.bind(this);
    clientSpotColumn.minWidth = this.nineWs;
    clientSpotColumn.width = this.nineWs;
    clientSpotColumn.disableInPicker = true;
    clientSpotColumn.editable = true; // always editable
    clientSpotColumn.cellEditor = "clientSptSpinner";
    clientSpotColumn.cellClass = "blotter_priority_col blotter_amt_align client-spot";
    if (!this.restoreFromConfig(clientSpotColumn)) {
      clientSpotColumn.position = this.position.next();
    }
    td.addColumn(clientSpotColumn);

    // clientPts
    let clientPtsColumn: BfxColDef = { suppressMenu: true };
    clientPtsColumn.field = "forwardPoints";
    clientPtsColumn.headerName = "Client Pts";
    clientPtsColumn.valueFormatter = this.formatPoints.bind(this);
    clientPtsColumn.minWidth = this.nineWs;
    clientPtsColumn.width = this.nineWs;
    clientPtsColumn.disableInPicker = true;
    clientPtsColumn.editable = this.fwdIsEditable.bind(this);
    clientPtsColumn.cellEditor = "clientPtsSpinner";
    clientPtsColumn.cellClass = "blotter_priority_col blotter_amt_align fwdEdit";
    clientPtsColumn.valueGetter = (params) => {
      let order: CubiqTS.OrderDataImpl = params.data;
      return order.product === CubiqTS.Product.SPT ? null : params.data.forwardPoints;
    };
    if (!this.restoreFromConfig(clientPtsColumn)) {
      clientPtsColumn.hide = !this.fwdColsEnabled;
      clientPtsColumn.position = this.position.next();
    }
    td.addColumn(clientPtsColumn);

    // Client All-In
    let clientForwardRateColumn: BfxColDef = { suppressMenu: true };

    clientForwardRateColumn.field = "allInClientRate";
    clientForwardRateColumn.headerName = "Client All-In";
    clientForwardRateColumn.valueFormatter = this.formatRate.bind(this);
    clientForwardRateColumn.minWidth = this.nineWs;
    clientForwardRateColumn.width = this.nineWs;
    clientForwardRateColumn.disableInPicker = true;
    clientForwardRateColumn.editable = this.fwdIsEditable.bind(this);
    clientForwardRateColumn.cellEditor = "clientAllInSpinner";
    clientForwardRateColumn.cellClass = "blotter_priority_col blotter_amt_align fwdEdit";
    clientForwardRateColumn.valueGetter = (params) => {
      let order: CubiqTS.OrderDataImpl = params.data;
      return order.product === CubiqTS.Product.SPT ? null : params.data.allInClientRate;
    };
    if (!this.restoreFromConfig(clientForwardRateColumn)) {
      clientForwardRateColumn.hide = !this.fwdColsEnabled;
      clientForwardRateColumn.position = this.position.next();
    }
    td.addColumn(clientForwardRateColumn);

    // Sales Margin
    let salesMarginColumn: BfxColDef = { suppressMenu: true };
    salesMarginColumn.valueFormatter = this.formatRate.bind(this);
    salesMarginColumn.field = "markup";
    salesMarginColumn.headerName = "Markup";
    salesMarginColumn.minWidth = this.sixWs;
    salesMarginColumn.width = this.sixWs;
    salesMarginColumn.cellClass = "blotter_amt_align";
    if (!this.restoreFromConfig(salesMarginColumn)) {
      salesMarginColumn.position = this.position.next();
    }
    td.addColumn(salesMarginColumn);

    // order type
    let orderTypeColumn: BfxColDef = { suppressMenu: true };

    orderTypeColumn.field = "requestedOrderType";
    orderTypeColumn.headerName = "Order Type";
    orderTypeColumn.field = COLUMN_ORDER_TYPE;
    orderTypeColumn.cellRenderer = RENDERER_ORDER_TYPE_FUNC;
    orderTypeColumn.alias = [COLUMN_ORDER_TYPE];
    orderTypeColumn.cellClass = "";
    orderTypeColumn.minWidth = this.oneWs;
    orderTypeColumn.cellClass = ["blotter_center_align"];
    orderTypeColumn.width = this.sixWs;
    orderTypeColumn.valueGetter = function (params) {
      return this.myOrderTypeHelper.getType(params.data);
    }.bind(this);
    if (!this.restoreFromConfig(orderTypeColumn)) {
      orderTypeColumn.position = this.position.next();
    }
    td.addColumn(orderTypeColumn);

    // product: spot/fwd/fwd off/ndf etc
    let productColumn: BfxColDef = { suppressMenu: true };

    productColumn.field = "product";
    productColumn.headerName = "Product";
    productColumn.alias = [COLUMN_ORDER_PRODUCT, COLUMN_INTER_ORDER_PRODUCT];
    productColumn.minWidth = this.oneWs;
    productColumn.width = this.fourWs;
    productColumn.valueFormatter = this.formatProduct.bind(this);
    if (!this.restoreFromConfig(productColumn)) {
      productColumn.position = this.position.next();
    }
    td.addColumn(productColumn);

    if (this.myVehiclCcyEnabled) {
      // vehicle: needs to be configured
      let vehiclCcyColumn: BfxColDef = { suppressMenu: true };
      vehiclCcyColumn.field = "vehicleCcy";
      vehiclCcyColumn.headerName = "Vehicle Ccy";
      vehiclCcyColumn.editable = (params: IsColumnFuncParams) => {
        return params.node.data != null && params.node.data.isComponentLeg == false;
      };
      vehiclCcyColumn.hide = true;
      vehiclCcyColumn.cellClass = "blotter_priority_col left_col autocomplete-col vehicle-ccy";
      vehiclCcyColumn.cellEditor = "vehicleAuto";
      vehiclCcyColumn.minWidth = this.fiveWs;
      vehiclCcyColumn.width = this.fiveWs;
      vehiclCcyColumn.valueFormatter = (params: ValueFormatterParams) =>
        params.value == null ? "-" : params.value;
      if (!this.restoreFromConfig(vehiclCcyColumn)) {
        vehiclCcyColumn.position = this.position.next();
      }
      td.addColumn(vehiclCcyColumn);
    }

    // value date
    let valueDateColumn: BfxColDef = { suppressMenu: true };

    valueDateColumn.field = COLUMN_VALUE_DATE;
    valueDateColumn.headerName = "Value Date";
    valueDateColumn.cellClass =
      "blotter_center_align_col prevent_stop_editing_when_grid_loses_focus";
    valueDateColumn.alias = [COLUMN_VALUE_DATE];
    valueDateColumn.minWidth = this.oneWs;
    valueDateColumn.width = this.sixWs;
    valueDateColumn.indexType = IndexType.Double;
    valueDateColumn.editable = true;
    valueDateColumn.cellEditor = "valueDateCalendar";
    valueDateColumn.valueGetter = function (params) {
      if (params.data.lockedValueDate == null) {
        params.data.lockedValueDate = this.myValueDateHelper.getMoment(
          params.data,
          params.data.isForwardAsSpot,
        );
      }

      return this.myValueDateHelper.getMoment(params.data, params.data.isForwardAsSpot);
    }.bind(this);
    valueDateColumn.cellRenderer = function (params) {
      const icon =
        (params.data?.orderType === CubiqTS.OrderType.LIMIT_SL ||
          params.data?.orderType === CubiqTS.OrderType.LIMIT_TP ||
          params.data?.orderType === CubiqTS.OrderType.LIMIT_CALL) &&
        params.data?.strategyType !== CubiqTS.StrategyType.GAMMA
          ? `<i class="` +
            `bfx-field-icon-end bfx-ignore-target fa fa-fw icon-calendar_month"` +
            ` alt="Amend Value Date" title="Amend Value Date"></i>`
          : ``;

      if (params.data?.valueDateInvalid === true) {
        return `<span style="color: var(--ds-cont-color-action-negative-base)">${this.myValueDateHelper.formatValueDate(
          params.data.valueDate,
        )}</span>${icon}`;
      } else if (params.data?.valueDateRequested === true) {
        return `<span style="color: var(--ds-cont-color-field-accent)">${this.myValueDateHelper.formatValueDate(
          params.data.valueDate,
        )}</span>${icon}`;
      } else if (params.value) {
        return `<span>${this.myValueDateHelper.formatValueDate(params.value)}</span>${icon}`;
      }
      return "-";
    }.bind(this);
    if (!this.restoreFromConfig(valueDateColumn)) {
      valueDateColumn.position = this.position.next();
    }
    td.addColumn(valueDateColumn);

    // STP
    let stp: BfxColDef = { suppressMenu: true };
    stp.field = "stp";
    stp.headerName = "STP";
    stp.minWidth = this.oneWs;
    stp.cellEditor = "stpCheckBox";
    stp.width = this.threeWs;
    stp.cellClass = "blotter_priority_col blotter_center_align_col boolean_val stp-col";
    stp.hide = true;
    stp.editable = function (params: IsColumnFuncParams) {
      let isEditable =
        params != null &&
        params.node != null &&
        params.node.data != null &&
        params.node.data.canOverRideStp &&
        params.node.data.isComponentLeg == false;

      return isEditable;
    }.bind(this);
    stp.valueFormatter = (params) => {
      return params.value ? "Yes" : "No";
    };
    if (!this.restoreFromConfig(stp)) {
      stp.position = this.position.next();
    }
    td.addColumn(stp);

    // Position Book
    let positionBookColumn: BfxColDef = { suppressMenu: true };

    positionBookColumn.field = "positionBookName";
    positionBookColumn.headerName = "Position Book";
    positionBookColumn.cellEditor = "posBookAutoComplete";
    positionBookColumn.minWidth = this.nineWs;
    positionBookColumn.width = this.nineWs;
    positionBookColumn.cellClass = "blotter_priority_col left_col autocomplete-col";
    positionBookColumn.valueFormatter = this.formatComment.bind(this);
    positionBookColumn.editable = function (params: IsColumnFuncParams) {
      let data: any = params.node.data;

      return (
        data != null &&
        !(
          data.requestedOrderType == CubiqTS.RequestOrderType.CALL ||
          (data.isComponentLeg && !data.legEnabled) ||
          (!data.isComponentLeg &&
            !(params.node != null && params.node.isSelected && params.node.isSelected())) ||
          (data.leg1 != undefined && data.leg2 != undefined)
        )
      );
    }.bind(this);
    if (!this.restoreFromConfig(positionBookColumn)) {
      positionBookColumn.position = this.position.next();
    }
    td.addColumn(positionBookColumn);

    // Client Comment
    let clientCommentColumn: BfxColDef = { suppressMenu: true };

    clientCommentColumn.field = "clientComment";
    clientCommentColumn.headerName = "Client Comments";
    clientCommentColumn.minWidth = this.oneWs;
    clientCommentColumn.width = this.nineWs;
    clientCommentColumn.showTooltip = true;
    clientCommentColumn.valueFormatter = this.formatComment.bind(this);
    if (!this.restoreFromConfig(clientCommentColumn)) {
      clientCommentColumn.position = this.position.next();
    }
    td.addColumn(clientCommentColumn);

    if (this.myPrivateCommentsEnabled) {
      // Private Comment
      let privateCommentColumn: BfxColDef = { suppressMenu: true };
      privateCommentColumn.field = "privateComment";
      privateCommentColumn.headerName = "Private Comments";
      privateCommentColumn.minWidth = this.oneWs;
      privateCommentColumn.width = this.nineWs;
      privateCommentColumn.showTooltip = true;
      privateCommentColumn.valueFormatter = this.formatComment.bind(this);
      if (!this.restoreFromConfig(privateCommentColumn)) {
        privateCommentColumn.position = this.position.next();
      }
      td.addColumn(privateCommentColumn);
    }

    // Order id
    let orderIdColumn: BfxColDef = { suppressMenu: true };

    orderIdColumn.field = "orderId";
    orderIdColumn.headerName = "Order ID";
    orderIdColumn.indexType = IndexType.Integer;
    orderIdColumn.minWidth = this.oneWs;
    orderIdColumn.width = BfxConfigIDRefHelper.getOrderRefWs();
    orderIdColumn.valueFormatter = BfxConfigIDRefHelper.orderRefValueFormatter;
    orderIdColumn.getQuickFilterText = BfxConfigIDRefHelper.orderRefValueFormatter;
    if (!this.restoreFromConfig(orderIdColumn)) {
      orderIdColumn.position = this.position.next();
    }
    td.addColumn(orderIdColumn);

    // Entry Date - not available in API
    let entryDateColumn: BfxColDef = { suppressMenu: true };
    entryDateColumn.field = "entryDate";
    entryDateColumn.headerName = "Entry Date";
    entryDateColumn.minWidth = this.oneWs;
    entryDateColumn.width = this.nineWs;
    entryDateColumn.indexType = IndexType.Double;
    entryDateColumn.hide = false;
    entryDateColumn.disableInPicker = false;
    entryDateColumn.valueFormatter = this.formatMomment.bind(this);
    if (!this.restoreFromConfig(entryDateColumn)) {
      entryDateColumn.position = this.position.next();
    }
    td.addColumn(entryDateColumn);

    if (this.enabledOBO) {
      // OBO Client
      let oboClient: BfxColDef = { suppressMenu: true };
      oboClient.headerName = "OBO Client";
      oboClient.field = "oboClient";
      oboClient.minWidth = this.oneWs;
      oboClient.width = this.sevenWs;
      oboClient.columnFilterType = ColumnFilterType.NONE;
      oboClient.valueFormatter = (params: ValueFormatterParams) => {
        return params.value == null ? "-" : params.value;
      };

      if (!this.restoreFromConfig(oboClient)) {
        oboClient.hide = true;
        oboClient.position = this.position.next();
      }

      td.addColumn(oboClient);
    }

    this.processEditableColumns(td);

    return td;
  }

  private processEditableColumns(td: TableDefinition) {
    td.columns.forEach((c) => {
      if (c.cellClassRules == null) {
        c.cellClassRules = {};
      }

      c.cellClassRules[CLASS_EDITABLE] = (params) => {
        if (typeof params.colDef.editable == "function") {
          return params.colDef.editable(params);
        }

        return params.colDef.editable;
      };
    });
  }

  public getBlotterType(): BlotterType {
    return null;
  }

  protected getProfileSettingKey(): string {
    return `${ProfileSettingKeys.userProfileDefaultBlotter}DetailFill`;
  }

  public getAssetClass(): AssetClass {
    return AssetClass.FIX;
  }

  public getVersionIdentifier(): string {
    return DETAIL_FILL_TABLE_DEFINITION_VER;
  }

  protected getTableCongiPromises(): Array<Promise<any>> {
    return [
      this._sysConfigService.getSystemConfig(SysFeatures.featuresEnablePrivateComments),
      this._sysConfigService.getSystemConfig(SysFeatures.vehicleCcyFillingEnabled),
      this._sysConfigService.getSystemConfig(SysFeatures.fwdEnabled),
      this._sysConfigService.getSystemConfig(SysFeatures.ndfEnabled),
      this._sysConfigService.getSystemConfig(SysFeatures.partFillDisabledTypeText), // 4
    ];
  }
  // this override to set flags returned by promises
  protected handleTableCongiPromises(values: Array<any>) {
    this.myPrivateCommentsEnabled = this.valueOn(values[0]);
    this.myVehiclCcyEnabled = this.valueOn(values[1]);

    let fwdEnabled: boolean = this.valueOn(values[2]);
    let ndfEnabled: boolean = this.valueOn(values[3]);
    this.fwdColsEnabled = fwdEnabled || ndfEnabled;
    if (values[4] !== undefined || values[4] !== null) {
      // this may be configure to ''
      this.myPartFillDisabledTypeText = values[4];
    }

    this.myOrderTypeHelper = new OrderTypeHelper(
      this.myPartFillDisabledTypeText,
      this.algoStrategyLookupService,
      this.sysConfigUtil,
    );
  }

  public formatRate(params: ValueFormatterParams): string {
    if (params.value == null) {
      return params.data.product === CubiqTS.Product.SPT ? "" : "-";
    }

    let value: any = params.value;
    if (typeof params.value == "string") {
      value = new CubiqTS.BigNumber(params.value);
    }

    let minPrecision: number = params.data.minPrecision;
    let currentDecs: number = value.decimalPlaces();
    if (currentDecs < minPrecision) {
      return value.toFixed(minPrecision);
    }

    return value.toFixed(currentDecs);
  }

  public formatPoints(params: ValueFormatterParams): string {
    if (params != null && params.data != null && params.data.isComponentLeg) {
      return "-";
    }

    let ptsPrecision: number = null;
    let data: CubiqTS.OrderFillDataImpl = params.data as CubiqTS.OrderFillDataImpl;
    let order: CubiqTS.OrderDataImpl = params.data.parentOrder
      ? params.data.parentOrder
      : this._orderDataLookupService.getItem(data.orderId);
    let pair: CubiqTS.CurrencyPairImpl = this._ccyPairLookupService.getCcyPair(
      order.baseCode,
      order.nonBaseCode,
    );

    let decs: number = 4;
    let pips: number = 4;
    if (order.product === CubiqTS.Product.FWD || order.product === CubiqTS.Product.NDF) {
      if (order.isInvertedOrderFg) {
        decs = Math.max(
          pair.fwdInvertDecimalsQty,
          pair.markupSptInvDecimals,
          pair.limitEntrySpotInvertDecimals,
        );
        pips = pair.fwdInvertPipsQty;
      } else {
        decs = Math.max(
          pair.fwdRateDecimalsQty,
          pair.markupSptDecimals,
          pair.limitEntrySpotDecimals,
        );
        pips = pair.fwdPipsQty;
      }
      ptsPrecision = decs - pips;
    } else {
      if (order.isInvertedOrderFg) {
        decs = Math.max(
          pair.spotInvertDecimalsQty,
          pair.markupSptInvDecimals,
          pair.limitEntrySpotInvertDecimals,
        );
        pips = pair.spotInvertDecimalsQty; // NB TODO = no Invert spot pips on the pair ??
      } else {
        decs = Math.max(pair.rateDecimalsQty, pair.markupSptDecimals, pair.limitEntrySpotDecimals);
        pips = pair.rateDecimalsQty;
      }
      ptsPrecision = decs;
    }

    let value: any = params.value;
    if (typeof params.value == "string") {
      value = new CubiqTS.BigNumber(params.value);
    }

    if (value == null) {
      value = new CubiqTS.BigNumber(0);
    }

    return order.product === CubiqTS.Product.SPT || params.data.isForwardAsSpot === true
      ? ""
      : value.toFixed(ptsPrecision);
  }

  public formatProduct(params: ValueFormatterParams): string {
    if (params.data && params.data.isForwardAsSpot === true) {
      return "Spot";
    }

    switch (params.value) {
      case CubiqTS.Product.SPT:
        return "Spot";
      case CubiqTS.Product.FWD:
        return CubiqTS.RequestTrackingType.OUTRIGHT_RATE === params.data.requestTrackingType
          ? "Fwd"
          : "Fwd (Spot)";
      case CubiqTS.Product.NDF:
        return CubiqTS.RequestTrackingType.OUTRIGHT_RATE === params.data.requestTrackingType
          ? "NDF"
          : "NDF (Spot)";
    }
    return "";
  }

  protected formatComment(params: ValueFormatterParams): string {
    return params.value != null ? params.value : "-";
  }

  protected formatRemainingAmt(params: ValueFormatterParams): string {
    if (!params.data.isComponentLeg) {
      const dealtCcy: string =
        typeof params.data.dealtCcy === "string" ? params.data.dealtCcy : null;
      let precisionLimit = 2;
      if (dealtCcy) {
        const ccy: CubiqTS.CurrencyImpl = this._ccyLookupService.getItem(params.data.dealtCcy);
        if (ccy != null) {
          precisionLimit = ccy.minorUnitsQty.toNumber();
        }
      }

      let amt = this.formatAmts(params, precisionLimit);
      if (amt != "-" && dealtCcy) return `${amt} ${dealtCcy}`;
    }
    return "-";
  }

  protected formatAmts(params: ValueFormatterParams, precisionLimit: number = 2): string {
    if (params.value) {
      if (params.value instanceof CubiqTS.BigNumber) {
        if (params.value.decimalPlaces() > 0) {
          return params.value.decimalPlaces(precisionLimit).toFormat(precisionLimit);
        } else {
          return params.value.toFormat(0);
        }
      } else if (typeof params.value == "string") {
        return params.value;
      } else if (typeof params.value == "number") {
        return params.value.toString();
      }
    }
    return "-";
  }
}
